import React, {useContext} from "react";
import "./Skills.scss";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import {skillsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Skills() {
  const {isDark} = useContext(StyleContext);

  if (!skillsSection.display) return null;

  return (
    <Fade bottom duration={800} distance="20px">
      <section className={isDark ? "dark-mode main skills-section" : "main skills-section"} id="skills">
        <div className="editorial-heading">
          <span>01 / CAPABILITIES</span>
          <h2>{skillsSection.title}</h2>
        </div>

        <div className="skills-layout">
          <div className="skills-intro">
            <p className="skills-lead">
              {skillsSection.subTitle}
            </p>
            <p className="skills-description">
              I mostly work on backend services, and full-stack stuff when it's needed. I'm not really one for flashy features — I'd rather 
              write code that still makes sense to someone else a few months later, and doesn't fall apart the moment real users start using it.
            </p>
          </div>

          <div className="skills-list">
            {skillsSection.skills.map((skill, i) => (
              <div className="skill-statement" key={i}>
                <span>0{i + 1}</span>
                <p>{skill}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="skills-tools">
          <div className="tools-label">TOOLS / TECHNOLOGIES</div>
          <SoftwareSkill />
        </div>
      </section>
    </Fade>
  );
}
